<template>
    <div class="header" :class="menu_collapse">
        <b-navbar toggleable="lg" type="light" variant="light" class="header-front">
            <div class="container" style="padding-top: 0px;padding-bottom: 0px;">
                <a href="https://alumni.fbeubaya.id/">
                    <img src="@/assets/images/logo-ika.png" alt="" class="logo-front" style="width: 80px;height: 80px;">
                </a>
            </div>
        </b-navbar>
    </div>
</template>
<script>
    import { Icon } from '@iconify/vue2'
    export default {
        name: 'HeaderFrontend',
        components: {
            Icon
        },
        data () {
            return {
                token: localStorage.getItem('token'),
                active_header: '',
                menu_collapse: ''
            }
        },
        created () {
            if (this.$route.matched[0]) {
                this.get_active_header()
            }
        },
        watch: {
            $route: 'get_active_header'
        },
        methods: {
            activate: function (el) {
                this.active_header = el
            },
            get_active_header () {
                this.active_header = this.$route.matched[0].path
            },
            menuCollapse () {
                this.menu_collapse = 'menu-collapse'
            },
            menuHide () {
                this.menu_collapse = ''
            }
        }
    }
</script>
